<div class="content-pane readable">
  <div class="content">
    <div class="content-body">
      <div class="content-main">
        <div class="content-container no-indent">
          <div class="content-header">
            <h2>{{ dataset()?.name }}</h2>
          </div>
          <div class="content-toolbar">
            @if(dataset()?.link_to_external_dataset){
            <a
              [href]="dataset().link_to_external_dataset"
              target="_blank"
              rel="noopener"
              class="content-header-action toolbar-action"
            >
              <mat-icon class="material-symbols-outlined">open_in_new</mat-icon>
              View External Dataset
            </a>
            } @if(dataset()?.is_data_public && downloadLink.hasValue()){
            <a
              class="content-header-action toolbar-action"
              [href]="downloadLink.value().url"
              [download]="downloadLink.value().file_name"
            >
              <mat-icon class="material-symbols-outlined">download</mat-icon>
              Download Latest Version ({{formatFileSize(downloadLink.value().size)}})
            </a>
            }
          </div>

          @if(activeFileVersionsCount() === 0) {
          <div class="unavailable-message">
            <b>Dataset Files:</b> No dataset files have been uploaded to this dataset.
          </div>
          } @else if(dataset()?.is_data_public === false && activeFileVersionsCount() > 0) {
          <div class="unavailable-message"> <b>Dataset Files:</b> The associated dataset file is not public. </div>
          }

          <div class="description" [innerHTML]="safeDescription()"></div>
          <div class="meta-subcontent">
            <app-key-value-table [rowsToDisplay]="buildKeyValueTable()"></app-key-value-table>
          </div>

          @if(dataset()?.dataset_type == "DICOM"){
          <p>The fields listed below are automatically populated from the most recently uploaded DICOM file.</p>
          <div class="meta-subcontent">
            <app-key-value-table [rowsToDisplay]="buildDicomTable()"></app-key-value-table>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
